
<template>
	<footer class="footer">
		<div class="i_maxW">
			<div class="i_copyright">
				{{copyRight}}
			</div>
		</div>
	</footer>
</template>

<script>
export default {
    data() {
        return {
           copyRight:'',
        };
    },
    created() {
        this.getCpoyRight();
    },
    methods: {
    	getCpoyRight(){
    		let success = data => {
                this.copyRight = data.data.info.info_copyright;
            };
            let fail = data => {}
            this.$ajax({
                url: "api/setting/page_foot",
                method: "get",
                params: {},
                func: {
                    success: success,fail:fail
                }
            });
    	}
    }
 }

</script>
<style lang="scss">
.footer {
  background-color: #111f3f;
}
.i_copyright {
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: rgba(75, 106, 173, 1);
}
</style>
